import React from 'react'
import Header from '../Header'
import CameraDetails from './CameraDetails'
import injectSheet from 'react-jss'
import numeral from 'numeral'
import style from './style'
import last from 'ramda/src/last'
import head from 'ramda/src/head'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import firstCamerasManufacturer from 'helpers/firstCamerasManufacturer'

const resolutionText = ({ lowI, highI }, orderedResolutions) => {
  if (lowI === 0 && highI === orderedResolutions.length - 1) return 'Any'
  else if (lowI === 0) return `${orderedResolutions[highI].name} and lower`
  else if (highI === orderedResolutions.length - 1) return `${orderedResolutions[lowI].name} and higher`
  else return `${orderedResolutions[lowI].name} to ${orderedResolutions[highI].name}`
}

const irText = ({ min, max }) => {
  if (min === 0 && max === 500) return 'Any'
  else if (min === 0) return `${max}m and lower`
  else if (max === 500) return `${max}m and lower`
  else return `${min}m to ${max}m`
}

const formText = formFactors =>
  [0, 8].includes(formFactors.length) ? 'Any' : formFactors.map(capitalizeFirstLetter).join(', ')

const haovText = range => {
  if (head(range) === 1 && last(range) === 360) return 'Any'
  else if (head(range) === 1) return `${last(range)}° and lower`
  else if (last(range) === 360) return `${head(range)}° and higher`
  else return `${head(range)}° to ${last(range)}°`
}

const ModelCountDisplay = ({ classes, modelCount, filters, orderedResolutions,
  selectedManufacturer, manufacturerSpecificCameraModels, lensSelector }) =>
  modelCount > 0 && !lensSelector
  ? (
    <div className={classes.ModelCountDisplay}>
      Choose from<br />
      <strong>
        {manufacturerSpecificCameraModels && firstCamerasManufacturer(manufacturerSpecificCameraModels)} {numeral(modelCount).format('0,0')} cameras
      </strong>
      <div className={classes.filterSummary}>
        <strong>Brand:</strong> { selectedManufacturer || 'Any' }<br />
        <strong>Resolutions:</strong> { resolutionText(filters.resolutions, orderedResolutions) }<br />
        <strong>Form:</strong> { formText(filters.formFactors) }<br />
        <strong>IR Max Range:</strong> { irText(filters.ir) }<br />
        <strong>HAoV:</strong> { haovText(filters.aovRange) }<br />
        <strong>Show EOL Cameras:</strong> { filters.hideDiscontinued ? 'No' : 'Yes' }<br />
        <strong>Show Only NDAA Compliant:</strong> { filters.hideNonCompliant ? 'Yes' : 'No' }
      </div>
      <hr className={classes.break} />
      <a
        href={`${IPVM_URL}/contact?subject=Camera To Add&message=Please add`}
        target='_blank'
        className={classes.missingCameraLink}
      >
        Missing camera?
        <br />
        Request us to add a missing camera now
      </a>
    </div>
  ) : <div />

const CameraDetailsContainer = ({ classes, modelCount, selectedCamera, changeCameraModelAction, permalink,
  filters, orderedResolutions, selectedManufacturer, manufacturerSpecificCameraModels, lensSelector }) =>
  <div className={classes.CameraDetailsContainer}>
    <Header title='Info' />
    <div className={classes.list}>
      { selectedCamera
          ? <CameraDetails {...{ selectedCamera, changeCameraModelAction, permalink }} />
          : <ModelCountDisplay {...{ modelCount, classes, filters, orderedResolutions, selectedManufacturer, manufacturerSpecificCameraModels, lensSelector }} />
      }
    </div>
  </div>

export default injectSheet(style)(CameraDetailsContainer)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/index.js